import { Injectable } from '@angular/core';
import { SalesByPeriodExportQuery, SalesByPeriodExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByPeriodExportQuery)
@Wrapper(SalesByPeriodExportQueryHandlerBase)
export class SalesByPeriodExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
